import { QueryClient } from '@tanstack/react-query';
import { SystemPermission_Permission } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { LoaderFunctionArgs } from 'react-router';
import { getSystemQuery } from '~/shared/api/system.queries';
import { listSystemDesignAlertsQuery } from '~/shared/api/systemDesignAlerts.queries';
import {
  checkAuthorization,
  requireUserPermissionForSystemId,
} from '~/shared/auth/auth-utils';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';
import { assertIsDefined } from '~/types/assert-type';

export const systemDetailsPageLoader =
  (queryClient: QueryClient) =>
  async ({ params, request }: LoaderFunctionArgs) => {
    await checkAuthorization(queryClient, request);

    const { systemId } = params;

    assertIsDefined(systemId);

    await requireUserPermissionForSystemId(
      queryClient,
      request,
      [SystemPermission_Permission.DESIGN],
      systemId,
    );

    const [system, systemDesignAlerts] = await Promise.all([
      queryClient.ensureQueryData(getSystemQuery(systemId)),
      queryClient.ensureQueryData(
        listSystemDesignAlertsQuery(
          ResourceNameIdConverter.systemIdToName(systemId),
        ),
      ),
    ]);

    return {
      system,
      systemDesignAlerts,
    };
  };
